import { datadogRum } from "@datadog/browser-rum";
import { selectUserEmail } from "../../../../src/redux/app";
import { store } from "../../../../src/redux/reduxStore";

/**
 * Logs debug info to console and Datadog RUM, gated to internal users only.
 * Use for temporary debugging — remove after investigation.
 */
export function debugLog(message: string, data?: Record<string, unknown>) {
  const email = selectUserEmail(store.getState());
  if (!email.endsWith("@versemedical.com")) {
    return;
  }
  console.log(message, data ?? "");
  datadogRum.addAction(message, data);
}
